import React,{useEffect, useState} from 'react'
import arrow from '../images/arrow_white.png'
import key from '../images/key.png'
import sleepy_room from  "../images/sleepy_room.jpg"
import checkmark from '../images/checkmark.png'
import {ethers} from 'ethers';
import{provider,contract} from '../contracts/ogContract'
import { keys_contract } from '../contracts/keys_contract';
import axios from 'axios';
import { Dialog } from '@headlessui/react'
import FadeIn from 'react-fade-in';
import osLogo1 from '../images/opensea_logo.png'
import osLogo2 from '../images/opensea_2.png'
import "./fadeIn.css"
const aws_image_url = "https://slothphotos.s3.us-east-2.amazonaws.com/sleepy-rooms/"

function OpenSeaDial(){
    return(
        <div class='flex'>

<div onClick={() => window.open('https://opensea.io/collection/sleepy-house-keys')} class='bg-sky-700 hover:pr-8 duration-150 mx-auto rounded-full  text-[0px] hover:text-base cursor-pointer'>
 <img  class='mx-auto h-16   inline-block  ' src={osLogo2}></img>
 <h1 class='inline-block text-center '>{"View On Opensea"}</h1>
 </div>
 </div>
    )
}
function MyDialog(props) {
    let {isOpen,setIsOpen} = props;
  
    return (
        
        < div class={`flex justify-center items-center w-screen   fixed top-24  shadow-lg  duration-150 z-10 text-black ${isOpen==true ? "" : "hidden"} fade-in-image`}>
        
        <div class='bg-slate-100 px-4 py-1 rounded-md  '>
        <img class=' h-4  inline mr-2' src={checkmark}/>

            <h1 class='inline'>Succesfully Wrapped Asset</h1>

            </div>
            </div>
    )
  }

const Keys = () => {

    const[topImage,setTopImage] = useState(null);
    const[bottomImage,setBottomImage] = useState(null);

    const[keyNumber,setKeyNumber] = useState(null);
    const[verified,setVerified] = useState(null);
    const[isOpen,setIsOpen] = useState(false);
    const[succesfulRegen,setSuccesfulRegen] = useState(false);
    const[wrappingAgain,setWrappingAgain] = useState(false);
   
async function swapKeyState(){

    const provider = new ethers.providers.Web3Provider(window.ethereum,137);

    const signer = provider.getSigner();
    const message =  ethers.utils.solidityKeccak256(['address','string'],["0xC95DBB35c338F05e35EF45B014b2EaB8cfbea78B",'sleepy_key_regen']);

    const arrayifyMessage = ethers.utils.arrayify(message)


    const flatSignature = await signer.signMessage(arrayifyMessage);

    console.log(flatSignature);

    const res = await axios.post(`${process.env.REACT_APP_API_URL}/keys/changeWrappedStatus/${keyNumber}`,{holder_sig:flatSignature,arrayifyMessage})
    console.log(res.data)
    if(res.data.payload == "Success"){
        setIsOpen(true)
        setSuccesfulRegen(true)  
        setWrappingAgain(!wrappingAgain);
        setTimeout(()=>setIsOpen(false),3000)
    }
}

async function setImages() {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/keys/wrappedStatus/${keyNumber}`)
    const image_info = res.data;
    if(image_info.status ==0){
        setTopImage(key)
        setBottomImage(aws_image_url+`${keyNumber}.png`)
        console.log(aws_image_url+`${keyNumber}.png`)

    }
    if(image_info.status==1){
        setTopImage(aws_image_url+`${keyNumber}.png`)
        setBottomImage(key)
    }
}
useEffect(()=> {
   
        setImages()    
    

},[verified,succesfulRegen,wrappingAgain])


    async function listAccounts() {
        try{
            
            if(!window.ethereum){
                alert("Must Connect Wallet");
            }
            const tp = new ethers.providers.Web3Provider(window.ethereum,"any")
            const accounts = await tp.listAccounts();
            const curr_user = accounts[0]
            
            if(parseInt(keyNumber) >1 || parseInt(keyNumber) <=777){
            const keyOwner =  await keys_contract.ownerOf(keyNumber);
            
            if(keyOwner == curr_user){
                setVerified(true);
            }
                else{
                    setVerified(false)
                    return;
            }
        }
           
            else{
                return;
            }

        }
    
      
        catch(err){
            console.log(err)

        }
    }


   

    const keyHeight = 'h-64 m-auto rounded-md'
  return (
      <>
  

      <div class={`flex h-view flex-col my-12`}>
            <div class='m-auto'>
            <h1>Enter Your Sleepy Key Number</h1>
            <input onChange={(e)=>setKeyNumber(e.target.value)} placeholder='123' class={`w-full rounded-md text-center text-black ${(verified==false)? "text-red-600" : ""} ${verified==true? "text-green-600" : ""}`}></input>
            <div class='w-full flex flex-col justify-center pt-2'>
            <button onClick={()=>listAccounts()} class={`bg-slate-500 px-6 hover:bg-slate-700 duration-150 rounded-full mx-auto `}>{!verified? "Verify" : "Verified"}</button>
                </div>
            </div>
      </div>


 {/* <img  class='mx-auto' src={osLogo1}></img> */}
 {!verified && <OpenSeaDial/>}



{ verified &&    <div  class='grid grid-cols-1   gap-y-8 mx-16 my-12'>
    <div>
        <img class={`${keyHeight} fade-in-image` } src={topImage}></img>
    </div>
    <div class='place-content-center flex flex-col'>
        <img src={arrow} class={`${succesfulRegen? "" : "animate-pulse"} h-16 md:h-18  mx-auto my-12 md:m-auto rotate-90`}></img>
      
        <button onClick={()=>swapKeyState()} class='bg-slate-500 hover:bg-slate-700 duration-150 px-8 my-6 rounded-lg mx-auto'>Wrap</button>
        <OpenSeaDial/>
    </div>
    <div class='fade-in-image'>
        <img class={`${keyHeight}`} src={`${bottomImage}`} ></img>
    </div>
    </div>}

    <MyDialog isOpen={isOpen} setIsOpen={setIsOpen}/>
   

    </>
  )
}

export default Keys